import EntityMapper from '../EntityMapper';

import BackgroundMusicHideCommand from '../../../../domain/entities/commands/BackgroundMusicHideCommand';
import ResourcesSet from '../../../../domain/entities/resources/ResourcesSet';

import BackgroundMusicCommandOptionsMapper, {
  BackgroundMusicCommandOptionsData,
} from '../../../value_objects/mappers/command_options/BackgroundMusicCommandOptionsMapper';

export interface BackgroundMusicHideCommandData {
  id: number;
  scene_id: number;
  type: 'background_music_hide';
  sound_id: number;
  options?: BackgroundMusicCommandOptionsData;
}

export default class BackgroundMusicHideCommandMapper
  implements
    EntityMapper<BackgroundMusicHideCommandData, BackgroundMusicHideCommand>
{
  private backgroundMusicCommandOptionsMapper: BackgroundMusicCommandOptionsMapper;

  constructor(private resourcesSet: ResourcesSet) {
    this.backgroundMusicCommandOptionsMapper =
      new BackgroundMusicCommandOptionsMapper();
  }

  public map(obj: BackgroundMusicHideCommandData): BackgroundMusicHideCommand {
    const options = this.backgroundMusicCommandOptionsMapper.map(
      obj.options || {},
    );
    return new BackgroundMusicHideCommand(
      obj.id,
      obj.scene_id,
      this.resourcesSet.getSoundResource(obj.sound_id),
      options,
    );
  }
}
